import Vue from "vue";
import Vuex from "vuex";
import * as actions from "./actions";
import * as mutations from "./mutations";
import * as getters from "./getters";
//import layoutSettings from "../constants/layout-settings";
Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    appVersion: "0.16.1017",
    apiKey: null,
    userId: null,
    userConfig: {},
    agentId: null,
    itineraryAgentId: null,
    itineraryAgentName: "",
    itineraryDepartment: "FIT",
    itineraryAgentCurrency: null,
    itineraryAgentDepartment: null,
    appSnackbar: { show: false, msg: "This is App Snackbar", color: "success" },
    localSettings: null,
    appToolbarInfo: "",
    loginTime: null,
    //7h !? https://tracker.globetrack.ie/issues/8099
    inactivityTime: 7 * 60 * 60 * 1000,
  },
  mutations,
  actions,
  getters,
});



// WEBPACK FOOTER //
// ./src/store/store.js